export const socketGetters = {
    getNamespaceSocket: state => (namespace) => {
        const namespaceSocket = state.namespaces[namespace];
        if (!namespaceSocket) {
            return;
        }
        return state.namespaces[namespace];
    },
};
